import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationPT from "./locales/pt.json";
import translationEN from "./locales/en.json";
import translationES from "./locales/es.json";
import translationFR from "./locales/fr.json";
import translationDE from "./locales/de.json";
import translationIT from "./locales/it.json";
import translationRU from "./locales/ru.json";
import translationZH from "./locales/zh.json";
import translationJA from "./locales/ja.json";
import translationKO from "./locales/ko.json";
import translationAR from "./locales/ar.json";
import translationHI from "./locales/hi.json";
import translationNL from "./locales/nl.json";
import translationTR from "./locales/tr.json";
import translationSV from "./locales/sv.json";
import translationPTPT from "./locales/pt-pt.json";

// the translations
const resources = {
  pt: {
    translation: translationPT,
  },
  "pt-pt": {
    translation: translationPTPT,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
  it: {
    translation: translationIT,
  },
  ru: {
    translation: translationRU,
  },
  zh: {
    translation: translationZH,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  ar: {
    translation: translationAR,
  },
  hi: {
    translation: translationHI,
  },
  nl: {
    translation: translationNL,
  },
  tr: {
    translation: translationTR,
  },
  sv: {
    translation: translationSV,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "pt");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "pt",
    fallbackLng: "pt", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
